import { Field, Form, Formik } from 'formik';
import { Button, FormGroup, Input } from 'reactstrap';
import React from 'react';
import { connect } from 'react-redux';
import { saveUser } from '../../actions/users';
import { Label } from '../../components';

export const User = ({ data, onSubmit }) => {
  const initialValues = {
    seq: null,
    username: '',
    name: '',
    boToCode: '',
    userRole: 'ROLE_DOB',
    designation: 'EMPLOYEE',
    agentId: '91000001',
    email: '',
    ...data,
  };

  return (
    <div>
      <Formik initialValues={initialValues} onSubmit={onSubmit} enableReinitialize={true}>
        <Form>
          <legend className='h3 text-uppercase text-primary'>Thông tin người dùng</legend>
          <FormGroup>
            <Label htmlFor='username'>Username</Label>
            <Field name='username' id='username' as={Input} />
          </FormGroup>

          <FormGroup>
            <Label htmlFor='name'>Tên người dùng</Label>
            <Field name='name' id='name' as={Input} />
          </FormGroup>

          <FormGroup>
            <Label htmlFor='boToCode'>BOTO Code</Label>
            <Field name='boToCode' id='boToCode' as={Input} />
          </FormGroup>

          <FormGroup>
            <Label htmlFor='userRole'>Role</Label>
            <Field name='userRole' id='userRole' as={Input} />
          </FormGroup>

          <FormGroup>
            <Label htmlFor='designation'>Designation</Label>
            <Field name='designation' id='designation' as={Input} />
          </FormGroup>

          <FormGroup>
            <Label htmlFor='agentId'>Agent code</Label>
            <Field name='agentId' id='agentId' as={Input} />
          </FormGroup>

          <FormGroup>
            <Label htmlFor='email'>Email</Label>
            <Field name='email' id='email' as={Input} />
          </FormGroup>

          <FormGroup>
            <Label htmlFor='bank'>Bank</Label>
            <Field name='bank' id='bank' as={Input} />
          </FormGroup>

          <Button type='submit'>Gửi</Button>
        </Form>
      </Formik>
    </div>
  );
};

const mapStateToProps = (state) => {
  const data = state?.user?.selected;
  return { data };
};

const mapDispatchToProps = { onSubmit: saveUser };

export default connect(mapStateToProps, mapDispatchToProps)(User);
